// ==========================================
// 5. LIST COMPONENT - Improved TypeScript
// ==========================================
// list.component.ts

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, Subject, takeUntil, map } from 'rxjs';
import { PaymentGatewayModel } from 'src/app/models/portal';
import { isGatewayComingSoon } from 'src/app/models/payment-constants';
import { selectWebsitePaymentGateways } from 'src/app/shared/store/_features/website/payments/website-payments.selector';

@Component({
  selector: 'app-payment-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
})
export class ListPortalPaymentsComponent implements OnInit, OnDestroy {
  paymentGateways$: Observable<PaymentGatewayModel[]>;
  isLoading = true;

  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private store: Store
  ) {
    this.paymentGateways$ = this.store.select(selectWebsitePaymentGateways);
  }

  ngOnInit(): void {
    // We use the stream to flip the loading switch once data arrives
    this.paymentGateways$
      .pipe(takeUntil(this.destroy$))
      .subscribe((gateways) => {
        if (gateways && gateways.length > 0) {
           // Slight artificial delay prevents flicker if data is instant, 
           // or remove setTimeout for production speed
           setTimeout(() => this.isLoading = false, 200);
        } else {
           this.isLoading = false;
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  isSoon(gatewayId: string): boolean {
    return isGatewayComingSoon(gatewayId);
  }

  trackByGatewayId(index: number, gateway: PaymentGatewayModel): string {
    return gateway.id;
  }
}